import { useEffect } from 'react';

export const useSEO = ({ title, description, keywords, ogImage, ogType = 'website', canonical }) => {
  useEffect(() => {
    // Update document title
    if (title) {
      document.title = `${title} | Helvetic Padel Series`;
    }

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription && description) {
      metaDescription.setAttribute('content', description);
    }

    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (keywords) {
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.setAttribute('name', 'keywords');
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.setAttribute('content', keywords);
    }

    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle && title) {
      ogTitle.setAttribute('content', `${title} | Helvetic Padel Series`);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription && description) {
      ogDescription.setAttribute('content', description);
    }

    const ogTypeTag = document.querySelector('meta[property="og:type"]');
    if (ogTypeTag && ogType) {
      ogTypeTag.setAttribute('content', ogType);
    }

    const ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage && ogImage) {
      ogImage.setAttribute('content', ogImage);
    }

    // Update Twitter tags
    const twitterTitle = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitle && title) {
      twitterTitle.setAttribute('content', `${title} | Helvetic Padel Series`);
    }

    const twitterDescription = document.querySelector('meta[property="twitter:description"]');
    if (twitterDescription && description) {
      twitterDescription.setAttribute('content', description);
    }

    const twitterImage = document.querySelector('meta[property="twitter:image"]');
    if (twitterImage && ogImage) {
      twitterImage.setAttribute('content', ogImage);
    }

    // Update canonical URL
    let canonicalTag = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (!canonicalTag) {
        canonicalTag = document.createElement('link');
        canonicalTag.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalTag);
      }
      canonicalTag.setAttribute('href', canonical);
    }

    // Cleanup function to reset to default values when component unmounts
    return () => {
      if (title) {
        document.title = 'Helvetic Padel Series - Switzerland\'s First Padel League';
      }
      
      if (metaDescription && description) {
        metaDescription.setAttribute('content', 'Join Switzerland\'s premier padel league! 500+ teams compete across all cantons in structured divisions. Register your team, improve your skills, and compete for the Swiss Finals. Open registration now!');
      }

      if (ogTitle && title) {
        ogTitle.setAttribute('content', 'Helvetic Padel Series - Switzerland\'s First Padel League');
      }

      if (ogDescription && description) {
        ogDescription.setAttribute('content', 'Join Switzerland\'s premier padel league! 500+ teams compete across all cantons in structured divisions. Register your team and compete for the Swiss Finals.');
      }

      if (twitterTitle && title) {
        twitterTitle.setAttribute('content', 'Helvetic Padel Series - Switzerland\'s First Padel League');
      }

      if (twitterDescription && description) {
        twitterDescription.setAttribute('content', 'Join Switzerland\'s premier padel league! 500+ teams compete across all cantons in structured divisions. Register your team and compete for the Swiss Finals.');
      }
    };
  }, [title, description, keywords, ogImage, ogType, canonical]);
};
